
export default function Solutions() {
  return (
    <section id="solutions" className="py-20 lg:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Employer Solutions */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-blue-600 via-blue-700 to-purple-700 p-10 lg:p-12 group hover:shadow-2xl transition-all duration-300">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30"></div>
            
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-xl mb-6">
                <i className="ri-briefcase-4-line text-4xl text-white"></i>
              </div>
              
              <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
                For Employers
              </h3>
              
              <p className="text-white/90 text-lg mb-6 leading-relaxed">
                Streamline your hiring process with our comprehensive employer solutions designed to find the perfect talent for your organization.
              </p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-white">
                  <i className="ri-check-line text-2xl mr-3 flex-shrink-0"></i>
                  <span className="text-lg">Access to extensive talent pool across industries</span>
                </li>
                <li className="flex items-start text-white">
                  <i className="ri-check-line text-2xl mr-3 flex-shrink-0"></i>
                  <span className="text-lg">Reduced time-to-hire with efficient processes</span>
                </li>
                <li className="flex items-start text-white">
                  <i className="ri-check-line text-2xl mr-3 flex-shrink-0"></i>
                  <span className="text-lg">Quality guarantees and replacement policies</span>
                </li>
              </ul>
              
              <a
                href="#contact"
                className="inline-flex items-center px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-100 transition-colors group-hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Explore Solutions
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>

          {/* Candidate Solutions */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-teal-600 via-teal-700 to-green-700 p-10 lg:p-12 group hover:shadow-2xl transition-all duration-300">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30"></div>
            
            <div className="relative z-10">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-xl mb-6">
                <i className="ri-user-star-line text-4xl text-white"></i>
              </div>
              
              <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
                For Job Seekers
              </h3>
              
              <p className="text-white/90 text-lg mb-6 leading-relaxed">
                Advance your career with personalized support and access to exclusive opportunities that match your skills and aspirations.
              </p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start text-white">
                  <i className="ri-check-line text-2xl mr-3 flex-shrink-0"></i>
                  <span className="text-lg">Expert career guidance and mentorship</span>
                </li>
                <li className="flex items-start text-white">
                  <i className="ri-check-line text-2xl mr-3 flex-shrink-0"></i>
                  <span className="text-lg">Professional resume and profile optimization</span>
                </li>
                <li className="flex items-start text-white">
                  <i className="ri-check-line text-2xl mr-3 flex-shrink-0"></i>
                  <span className="text-lg">Interview preparation and coaching support</span>
                </li>
              </ul>
              
              <a
                href="#contact"
                className="inline-flex items-center px-6 py-3 bg-white text-teal-700 font-semibold rounded-lg hover:bg-gray-100 transition-colors group-hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Find Opportunities
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
